export default __webpack_public_path__ + "static/media/pvc-regrinds.209601c0.jpg";